(function(){
  document.addEventListener('DOMContentLoaded', function() {
    console.log('article-scripts');
    let addToBtn = document.querySelectorAll('.variant_add_to_cart');
    addToBtn.forEach(elem => {
      elem.addEventListener('click', function(e) {
        e.preventDefault();
        let formData = {'items': []};
        let id = elem.getAttribute('data-variant-id');
        formData.items.push({'id': id,'quantity': 1});
        addToCart(formData);
      });
    })
      
    
    function addToCart(formData) {
       fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        console.log(response);
          if ( response.status == 200 ) {
            // let cartItems = document.querySelector('.cart-items'); 
            // cartItems.onCartUpdate();
            fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');
                  const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
                  for (const selector of selectors) {
                    const targetElement = document.querySelector(selector);
                    const sourceElement = html.querySelector(selector);
                    if (targetElement && sourceElement) {
                      targetElement.replaceWith(sourceElement);
                    }
                  }
                  let cartDraw = document.querySelector('cart-drawer');
                  cartDraw.classList.remove('is-empty');
                  cartDraw.classList.add('active');
                  document.querySelector('body').classList.add('overflow-hidden');
                  document.querySelector('quick-add-modal[open]')?.removeAttribute('open');
                  let cartCounter = document.querySelector('#cart-icon-bubble');
                  let cartCounterBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
                  let itemsSize = document.querySelectorAll('#CartDrawer-CartItems .cart-item').length;
                  if ( cartCounterBubble ) {
                    let textCounter = `<span aria-hidden="true">${itemsSize}</span><span class="visually-hidden">${itemsSize} items</span>`;
                    cartCounterBubble.innerHTML = textCounter;
                  } else {
                    let counter = document.createElement('div');
                    let textCounter = `<div class="cart-count-bubble"><span aria-hidden="true">${itemsSize}</span><span class="visually-hidden">${itemsSize} items</span></div>`;
                    cartCounter.insertAdjacentHTML('beforeend', textCounter);
                  }
                })
                .catch((e) => {
                  console.error(e);
                });
          } else {
            alert('Something goes wrong, write to support.');
          }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
 }, false);
})();